export default __webpack_public_path__ + "static/media/technology-banner.c487ba24.png";